import type { MemberModel } from '@/adapters/apiv1.g';
import type { Member } from '@/types/core/member';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend MemberModel to a frontend Member type.
 * @param model - API MemberModel response
 * @returns Member - UI-friendly Member object
 */
export function extractMember(model: MemberModel): Member {
  return {
    userId: model.user_id as UUID,
    name: model.profile?.name,
    email: model.profile?.email,
    role: undefined, // Not provided by MemberModel
  };
}
